import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TabCacheService {
  private childrenTabCache = new Map<string, string>([
    // default values
    ['dashboard', 'summary'],
    ['kpis', 'summary'],
  ]);

  setChildrenTabCache(parent: string, route: string) {
    this.childrenTabCache.set(parent, route);
  }

  getChildrenTabCache(parent: string): string {
    return this.childrenTabCache.get(parent) || 'summary';
  }

  storeChildrenTabCacheFromUrl(url: string) {
    const segments = this.getPathSegments(url);
    if (segments.length >= 2) {
      const parent = segments[0];
      const child = segments[1];
      this.setChildrenTabCache(parent, child);
    }
  }

  getPathSegments(url: string) {
    return url
      .split('?')[0]
      .split('/')
      .filter((s) => s);
  }
}
